// extracted by mini-css-extract-plugin
var _1 = "InventoryReportCardsSummary-module__card-content";
var _2 = "InventoryReportCardsSummary-module__container";
export { _1 as "card-content", _2 as "container" }
